// extracted by mini-css-extract-plugin
export var expandedRowWrapper = "_1c-6";
export var headerCell = "_1c-2";
export var rowWrapper = "_1c-4";
export var stickyAggregationCell = "_1c-a";
export var stickyAggregationRow = "_1c-7";
export var stickyColumnCell = "_1c-9";
export var stickyColumnHeaderCell = "_1c-8";
export var table = "_1c-1";
export var virtualRowWrapper = "_1c-5";
export var virtualTableContainer = "_1c-0";
export var white = "_1c-3";